<template>
  <div>
    <form :id="formId">
      <div class="row h-row-inputBox">
        <div class="col-sm-10 h-col-inputBox" style="width: 100%">
          <div class="h-inputLit">{{$t('Observe.fileName')}}:</div>
          <ejs-textbox class="e-input e-input-group" :id="this.baseType + 'backupFileName'"
                       name="backupFileName"
                       v-model="backupFileName"
                       maxlength="20"
                       placeholder="NeCfgBackup"
          />
        </div>
        <div class="error"></div>
      </div>
      <div class="row h-row-inputBox"></div>
      <div class="h-col-inputBox col-sm-12 nopadding" style="padding:18px 10px;">
        <div class="col-sm-1 row nopadding">
          <span class="icon hero-icon hero-icon-detailed" style="margin-left: -18px"></span>
        </div>
        <div class="col-sm-16 row">
          <div style="padding:0 10px;">{{tipFileName}}</div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "ConfigBackupFileNameOption",
  props: {
    baseType: String
  },
  data() {
    return {
      formId: this.baseType+'clientForm',
      backupFileName: "",
    }
  },
  computed: {
    tipFileName() {
      if (this.backupFileName == '' ||this.backupFileName == null) {
        return this.$t('MML.tipFileName') + "NeCfgBackup_20231214170204.zip";
      } else {
        return this.$t('MML.tipFileName') + this.backupFileName + "_20231214170204.zip";
      }
    }
  }
}
</script>

<style scoped>

</style>
